import React, { useState, Fragment } from 'react';
import { useRouter } from 'next/router';
import { ChangePasswordData } from 'types';
import { SignInWrapper } from 'containers/SignWrapper';
import { DynamicForm } from 'components/DynamicForm';
import { HeadComponent } from 'components/HeadComponent';
import { SeoHiddenContent } from 'components/SeoHiddenContent';
import { resetFormFields, resetSentFormFields } from './formFields';
import { changePassword } from 'api';
import { getPageDescription, getPageH1Title } from 'utils/seoFormatters';

import styles from './ResetPass.module.scss';

export const ResetPass = () => {
  const router = useRouter();
  const [sent, setSent] = useState(false);
  const [notification, setNotification] = useState({});

  const onSend = async (data: Record<string, any>) => {
    const response = await changePassword(data as ChangePasswordData);

    if (response.ok) {
      setSent(true);
    } else {
      setNotification({
        resetPasswordMessage: {
          mode: 'error',
          header: 'Server responds with error',
          message: response.message,
        },
      });
    }
  };

  const onContinue = () => {
    router.push('/sign-in').then(() => {});
  };

  const goToSignUp = () => {
    return router.push('/sign-up');
  };

  const sentIcon = {
    path: '/icons/checkbox/TickRounded.svg',
    width: '48',
    height: '48',
  };

  return (
    <Fragment>
      <HeadComponent
        headTitle="Reset Password | SENDY"
        ogData={[{prop: 'description', content: getPageDescription('resetPassword')}]}
      />
      <SeoHiddenContent title={getPageH1Title('resetPassword')} />
      <SignInWrapper>
        <div className={styles.container}>
          <div className={styles.contentWrapper}>
            {sent ? (
              <DynamicForm
                headerIcon={sentIcon}
                withBackground={true}
                buttonCaption="Continue"
                onSend={onContinue}
                fields={resetSentFormFields}
                notifications={notification}
              />
            ) : (
              <>
                <DynamicForm
                  withBackground={true}
                  buttonCaption="Continue"
                  onSend={onSend}
                  fields={resetFormFields}
                  notifications={notification}
                  marginMode="low"
                  underButtonContent={
                    <p className={styles.signUpMessage}>
                      Don&apos;t have an account?<span id="sign-in-page-sign-up" onClick={goToSignUp}>Sign Up</span>
                    </p>
                  }
                />
              </>
            )}
          </div>
        </div>
      </SignInWrapper>
    </Fragment>
  );
};
